import React from 'react';
import type { RefObject } from 'react';
import type { ParagraphItem } from '../../../@types';
import { Headline, TextLink } from '@oneaudi/unified-web-components';
import { ButtonContainerDiv, StyledTextLayoutItem, TextWrapperDiv } from './styledComponents';
import { getValidCtaAriaLabel } from '../../utils/ariaLabelHelper';
import { UeElement } from '@oneaudi/falcon-tools';
import { processBodyText } from './processBodyText';
import { renderTextWithFootnotesReferencesV2 } from '../feature-service-types';
import styled from 'styled-components';
import { SYS_SPACE_FIXED_600 } from '@oneaudi/unified-web-common';

interface Types {
  paragraphs: ParagraphItem[];
  justification: string;
  themeActive: string;
  eTextContent: RefObject<HTMLDivElement | null>;
}

const Paragraphs = ({ paragraphs, justification, themeActive, eTextContent }: Types) => {
  return (
    <span data-testid="paragraphs">
      {paragraphs.map((paragraph: ParagraphItem, index) => {
        const {
          headline,
          headlineOrder,
          headlineTag,
          ariaLabel,
          bodyText,
          ctaButtonLabel,
          ctaButtonOpenInNewTab,
          ctaButtonUrl,
        } = paragraph.fields;

        const processedCopy = processBodyText(bodyText);

        return (
          <Container key={headline} className={index === 0 ? 'first-paragraph' : ''}>
            {headline && (
              <Headline
                variant={{ type: 'headline', order: headlineOrder, weight: 'normal' }}
                tag={headlineTag}
                className="edirotial-text-headline"
                data-testid="paragraph-headline"
              >
                {renderTextWithFootnotesReferencesV2(headline)}
              </Headline>
            )}
            <TextWrapperDiv
              data-testid="paragraph-text-wrapper"
              align={justification}
              theme={themeActive}
              ref={eTextContent}
            >
              {bodyText ? processedCopy : null}
            </TextWrapperDiv>
            {ctaButtonUrl?.length > 0 && ctaButtonLabel?.length > 0 && (
              <StyledTextLayoutItem basis="auto">
                <ButtonContainerDiv align={justification}>
                  <TextLink
                    data-testid="paragraph-cta"
                    variant="standalone"
                    size="md"
                    target={ctaButtonOpenInNewTab === 'newTab' ? '_blank' : '_self'}
                    href={ctaButtonUrl}
                    onClick={() => {}}
                    icon="forward"
                    iconPosition="trailing"
                    aria-label={getValidCtaAriaLabel(ariaLabel, ctaButtonLabel)}
                  >
                    <UeElement type="text" property="ctaButtonLabel" label="CTA Label">
                      {ctaButtonLabel}
                    </UeElement>
                  </TextLink>
                </ButtonContainerDiv>
              </StyledTextLayoutItem>
            )}
          </Container>
        );
      })}
    </span>
  );
};

export default Paragraphs;

const Container = styled.div`
  margin-bottom: ${SYS_SPACE_FIXED_600};
`;
